import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { navItems } from './navItemsBuyer';
const notedinLogo = new URL('../../../../assets/images/notedin.png', import.meta.url).href;

// Utility function to check if a navigation item is active
function isNavItemActive({ href, pathname }: { href?: string; pathname: string }) {
  return href && pathname === href;
}

export function MobileNav() {
  const { pathname } = useLocation();
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const toggleDrawer = () => setDrawerOpen(!drawerOpen);

  return (
    <>
      {/* Menu Icon to toggle the drawer */}
      {!drawerOpen && (
        <IconButton
          onClick={toggleDrawer}
          sx={{
            position: 'fixed',
            top: 10,
            left: 10,
            zIndex: 1300,
            fontSize: '30px',
          }}
        >
          <MenuIcon />
        </IconButton>
      )}

      {/* Mobile Drawer */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={toggleDrawer}
        PaperProps={{
          sx: {
            width: { xs: 200, sm: 240 },
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
  <Box
  sx={{
    p: 2,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  }}
>
  <Box
    component="img"
    src={notedinLogo}
    alt="NotedIn Logo"
    sx={{ width: 120 }}
  />
  <IconButton onClick={toggleDrawer}>
    <CloseIcon />
  </IconButton>
</Box>


        <Divider />

        <Stack spacing={1} sx={{ p: 2 }}>
          {navItems.map(({ key, title, href, icon: IconComponent }) => {
            const active = isNavItemActive({ href, pathname });

            return (
              <Box
                key={key}
                component={Link}
                to={href || ''}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  p: '8px 16px',
                  borderRadius: 1,
                  textDecoration: 'none',
                  backgroundColor: 'transparent',
                  color: active ? 'text.primary' : 'text.secondary',
                  '&:hover': { backgroundColor: 'action.hover' },
                }}
              >
                {IconComponent && <IconComponent />}
                <Typography variant="body2">{title}</Typography>
              </Box>
            );
          })}
        </Stack>

        <Divider />

        <Box sx={{ p: 2 }}>
          <Button
            href="https://notedin.com/pro"
            target="_blank"
            variant="contained"
            fullWidth
            sx={{ fontSize: '14px' }}
          >
            Get Pro
          </Button>
        </Box>
      </Drawer>
    </>
  );
}
